import React, { createContext, useState, useContext } from 'react';
import { en } from './translations/en';
import { fr } from './translations/fr';
import { pt } from './translations/pt';

const translations = { en, fr, pt };
const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(localStorage.getItem('locale') || 'en');

  const t = (key) => {
    const keys = key.split('.');
    let translation = translations[locale];

    for (const k of keys) {
      translation = translation[k];
      if (!translation) return key;
    }

    return translation;
  };

  const changeLanguage = (newLocale) => {
    if (translations[newLocale]) {
      setLocale(newLocale);
      localStorage.setItem('locale', newLocale);
    }
  };

  return (
    <I18nContext.Provider value={{ t, locale, changeLanguage }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useTranslation = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useTranslation must be used within an I18nProvider');
  }
  return context;
};